import { ValidatorFn, Validators } from '@angular/forms';

export function LastNameValidator(): ValidatorFn {
    return Validators.pattern('^[A-ZŻŹĆĄŚĘŁÓŃÄÖÜ]{1}[a-zżźćńółęąśäöüß]+((|-)[A-ZŻŹĆĄŚĘŁÓŃÄÖÜ]{1}[a-zżźćńółęąśäöüß]+)?$');
}

export function SimplifiedLastNameValidator(): ValidatorFn {
    return Validators.pattern('^[^0-9@#$%]+$');
}
